/* unplugin-vue-components disabled */import { render } from "./TradeWithAcitveKey.vue?vue&type=template&id=2199f1f5"
import script from "./TradeWithAcitveKey.vue?vue&type=script&lang=js"
export * from "./TradeWithAcitveKey.vue?vue&type=script&lang=js"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__